import { SdkServiceStatus } from 'shared/api/contracts';

export const statusLabel = {
	[SdkServiceStatus.Blocked]: `Принудительная блокировка`,
	[SdkServiceStatus.Active]: `Активен`,
	[SdkServiceStatus.Test]: `Тестовый режим`,
	[SdkServiceStatus.VoluntaryBlocked]: `Добровольная блокировка`,
	[SdkServiceStatus.TestOut]: `Тестовый период завершен`,
};

export const ITEMS_PER_PAGE = 20;

export const EURO_SYMBOL_URI = `€`;
